import React, {useMemo} from 'react';
import {Route} from 'react-router';
import PropTypes from 'prop-types';
import DefaultLayout from './layout/DefaultLayout';
import {useRoles} from '../../hooks/useRoles';

const AppRoute = ({component: Component, layout: Layout, roles: propRoles, ...rest}) => {
    const roles = useRoles(propRoles);

    const renderContent = useMemo(() => (props) => (
        <Layout {...rest}>
            {(layoutProps) => {
                if (!Component) return null;
                return (
                    <Component
                        {...props}
                        roles={roles}
                        layoutProps={layoutProps}
                    />
                );
            }}
        </Layout>
        // eslint-disable-next-line
    ), [Component, Layout, roles, rest]);

    return <Route {...rest} render={renderContent}/>;
};

AppRoute.defaultProps = {
    layout: DefaultLayout
};

AppRoute.propTypes = {
    component: PropTypes.elementType,
    layout: PropTypes.elementType,
    roles: PropTypes.array
};

export default React.memo(AppRoute);